  var showMoreButton = document.getElementById('showMoreButton');
  var firstElement = document.querySelector('.list-item-1');
  var perRowHeight = firstElement.offsetHeight;
  var maxHeight = perRowHeight * 3;
  var hiddenItems = document.querySelector('.list-grid');

  let display_items = 13;

  var btn_text = document.querySelector('.btn-text');

  var plus = document.querySelector('.plus-icon');
  var minus = document.querySelector('.minus');

  showMoreButton.addEventListener('click', function() {

    if (btn_text.innerHTML === 'Show more') {
      btn_text.innerHTML = 'Show less';
      minus.style.display = 'block';
      plus.style.display = 'none';

      rows.forEach(function(row, index) {
        if (index >= display_items - 1) {
          row.style.display = 'block';  // Reset the default display property
          row.setAttribute('aria-hidden', 'false');
        }
      });

    } else {
      btn_text.innerHTML = 'Show more';
      minus.style.display = 'none';
      plus.style.display = 'block';


      rows.forEach(function(row, index) {
        if (index >= display_items - 1) {
          row.style.display = 'none';  // Hide the element
          row.setAttribute('aria-hidden', 'true');
        }
      });
    }
  });

  var rows = document.querySelectorAll('.list-item-search');
  rows.forEach(function(row, index) {
    if (index >= display_items - 1) {
      row.style.display = 'none';  // Initially hide the rows with index greater than 11
      row.setAttribute('aria-hidden', 'true');
      row.setAttribute('tabindex', '-1');
    } else {
      row.setAttribute('aria-hidden', 'false');
    }
  });


  document.getElementById('Homesearch').addEventListener('input', function() {
    var value = this.value.toLowerCase();
    let search_rows = document.querySelectorAll('.list-item-search');  
    let showAbleItem = 0

    search_rows.forEach(function(row) {
      var rowText = row.textContent.toLowerCase();

      if (rowText.indexOf(value) > -1) {
        row.style.display = ''; // Shows the row
        if (value != '') {
          row.classList.add('bg-white');
        } else {
          row.classList.remove('bg-white');
        }   
        showAbleItem++;

        if (showAbleItem > 13 && btn_text.innerHTML === 'Show more') {
            row.style.display = 'none'
        }

      } else {
        row.style.display = 'none'; // Hides the row
      }
    });
  });